/* framivo-size-rules.js - Framivo's size rules on the product page.
   Data: snippets/framivo-size-rules.liquid, from two metafields:

   product.metafields.framivo.size_limits
     { min, short, long, sheet_short, sheet_long } in cm. A frame is made
     standing or lying, so the short side may be at most 'short' and the long
     side at most 'long'. sheet_* is the size the frame can physically be made
     in; when that is larger than what the price grid covers, the message
     points the customer to us for the bigger formats.

   shop.metafields.framivo.attribute_size_limits
     { "<attribute id>": { short, long, fallback } } - choices that can only
     be made up to a size. Empty since 8 Oct 2026: all four glass types now
     come in every frame size, and the frame stand is built in (no choice). Above it the choice is unavailable, and
     if it was chosen the fallback is chosen instead (plexiglas for glass, no
     stand for the stand).

   Hooks into assets/maaho-product.js only through window.MaahoProductGroups.
   The checkout does not repeat these checks - see the note to Savvas. */

(function () {
  'use strict';
  /* Framivo i18n: tekster pr. sprog (html lang). Dansk er standard. */
  var FT_LANG = (document.documentElement.lang || 'da').slice(0, 2).toLowerCase();
  var FT = {
    "da": {
      "k10": " i stedet.",
      "k9": " – vi har valgt ",
      "k8": " kan kun vælges op til ",
      "k7": " cm kan bestilles ved at kontakte os.",
      "k6": " Større formater op til ",
      "k5": " cm – stående eller liggende.",
      "k4": "Rammen kan højst være ",
      "k3": " cm – <a href=\"/pages/contact\">kontakt os</a> for et tilbud på større formater.",
      "k2": " cm (stående eller liggende). Vi kan producere rammen op til ",
      "k1": "Kan bestilles online op til "
    },
    "sv": {
      "k10": " i stället.",
      "k9": " – vi har valt ",
      "k8": " kan bara väljas upp till ",
      "k7": " cm kan beställas genom att kontakta oss.",
      "k6": " Större format upp till ",
      "k5": " cm – stående eller liggande.",
      "k4": "Ramen kan som mest vara ",
      "k3": " cm – <a href=\"/pages/contact\">kontakta oss</a> för en offert på större format.",
      "k2": " cm (stående eller liggande). Vi kan tillverka ramen upp till ",
      "k1": "Kan beställas online upp till "
    },
    "nb": {
      "k10": " i stedet.",
      "k9": " – vi har valgt ",
      "k8": " kan bare velges opp til ",
      "k7": " cm kan bestilles ved å kontakte oss.",
      "k6": " Større formater opp til ",
      "k5": " cm – stående eller liggende.",
      "k4": "Rammen kan maksimalt være ",
      "k3": " cm – <a href=\"/pages/contact\">kontakt oss</a> for et tilbud på større formater.",
      "k2": " cm (stående eller liggende). Vi kan produsere rammen opp til ",
      "k1": "Kan bestilles på nett opp til "
    }
  };
  function fT(k) { var d = FT[FT_LANG] || FT.da; return d[k] != null ? d[k] : FT.da[k]; }


  var EPSILON = 0.0001;

  function init() {
    var groups = window.MaahoProductGroups;
    var config = window.framivoSizeRules;
    var widthInput = document.getElementById('measurement-width');
    if (!groups || !config || !widthInput) return;

    var heightInput = document.getElementById('measurement-length');
    var limits = config.product || null;
    var attributes = config.attributes || {};

    var row = widthInput.closest('.row');
    var note = document.createElement('p');
    note.className = 'framivo-size-note';
    note.setAttribute('role', 'status');
    note.hidden = true;
    /* Frames the workshop can make larger than the web shop sells: say so
       up front, so the customer knows to ask rather than give up. */
    var hasBiggerSheet = Boolean(limits) && (
      (limits.sheet_long || 0) > limits.long + EPSILON ||
      (limits.sheet_short || 0) > limits.short + EPSILON);
    if (hasBiggerSheet && row) {
      var offer = document.createElement('p');
      offer.className = 'framivo-size-offer';
      offer.innerHTML = fT('k1') + format(limits.short) + ' × ' + format(limits.long)
        + fT('k2')
        + format(limits.sheet_long) + ' × ' + format(limits.sheet_short)
        + fT('k3');
      row.appendChild(offer);
    }

    if (row) row.appendChild(note);

    var switched = {}; // attribute id -> name of what replaced it, for the note

    function format(number) {
      return String(Math.round(number * 10) / 10).replace('.', ',');
    }

    function size() {
      var width = parseFloat(widthInput.value);
      var height = heightInput && !heightInput.disabled ? parseFloat(heightInput.value) : width;
      if (isNaN(width) || isNaN(height)) return null;
      return { short: Math.min(width, height), long: Math.max(width, height) };
    }

    function exceeds(limit, current) {
      return Boolean(current) && (current.short > limit.short + EPSILON || current.long > limit.long + EPSILON);
    }

    function frameProblem(current) {
      if (!limits || !current || !exceeds(limits, current)) return '';
      var text = fT('k4') + format(limits.short) + ' × ' + format(limits.long)
        + fT('k5');
      if (hasBiggerSheet) {
        text += fT('k6') + format(limits.sheet_long) + ' × ' + format(limits.sheet_short)
          + fT('k7');
      }
      return text;
    }

    function choiceName(group, attributeId) {
      var element = group.values[attributeId];
      return element ? (element.getAttribute('data-v') || element.getAttribute('data-n') || '') : '';
    }

    function apply() {
      var current = size();
      var messages = [];

      var problem = frameProblem(current);
      if (problem) messages.push(problem);

      Object.keys(attributes).forEach(function (attributeId) {
        var group = groups.holding(attributeId);
        if (!group) return;
        var limit = attributes[attributeId];
        var over = exceeds(limit, current);
        group.setValueState(attributeId, { hidden: false, unavailable: over });

        if (over && String(group.chosenId()) === String(attributeId)) {
          var fallback = limit.fallback;
          if (fallback && group.canSelect(fallback)) {
            group.select(fallback);
            switched[attributeId] = choiceName(group, fallback);
          } else {
            group.clear();
            switched[attributeId] = '';
          }
        }
        if (!over) delete switched[attributeId];

        if (over && Object.prototype.hasOwnProperty.call(switched, attributeId)) {
          var limitText = format(limit.short) + ' × ' + format(limit.long) + ' cm';
          messages.push(choiceName(group, attributeId) + fT('k8') + limitText
            + (switched[attributeId] ? fT('k9') + switched[attributeId] + fT('k10') : '.'));
        }
      });

      [widthInput, heightInput].forEach(function (input) {
        if (input) input.classList.toggle('invalid-by-rule', Boolean(problem));
      });

      note.textContent = messages.join(' ');
      note.hidden = messages.length === 0;
      note.classList.toggle('is-error', Boolean(problem));

      groups.refresh();
    }

    groups.addReadinessCheck(function () { return !frameProblem(size()); });
    groups.onChange(apply);
    [widthInput, heightInput].forEach(function (input) {
      if (input) input.addEventListener('input', apply);
    });

    apply();
  }

  /* After maaho-product.js has registered its groups. */
  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  }
})();
